/* eslint-disable no-irregular-whitespace */
import { keyframes } from 'styled-components';

export const unMountAfterAnim = (state, dispatch) => {
  if (!state) {
    dispatch(null);
  }
};

export const easeInOutSine = 'cubic-bezier(0.37, 0, 0.63, 1)';
export const hoverTiming = '300ms';

export const breathingAnimLeft = keyframes`
  0% {
    transform: translateX(0);
    border-color: transparent #f4f4f4 transparent transparent;
}
100% {
    transform: translateX(-5px);
    border-color: transparent var(--blue-2) transparent transparent;
}
`;

export const breathingAnimRight = keyframes`
  0% {
    transform: translateX(0);
    border-color: transparent  transparent transparent #f4f4f4;
}
100% {
    transform: translateX(5px);
    border-color: transparent  transparent transparent var(--blue-2);
}
`;

export const fadeInAnim = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fadeOutAnim = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

export const slideInAnim = keyframes`
    0% {
        opacity: 0;
        transform: translateY(-100px)
    };
    100% {
        opacity: 1;
        transform: translateY(0px)
    }
`;

export const slideOutAnim = keyframes`
    0% {
        opacity: 1;
        transform: translateY(0px)
    };
    100% {
        opacity: 0;
        transform: translateY(-100px)
    };
`;

export const fadeInZoomAnim = keyframes`
 0% {
   opacity: 0;
   transform: scale(0.8);
   visibility: visible;
 }

 100% {
   opacity: 1;
   transform: scale(1);
 }
`;

export const fadeOutZoomAnim = keyframes`
 0% {
   opacity: 1;
   transform: scale(1);
 }

 100% {
   opacity: 0;
   transform: scale(0.8);
 }
`;

export const fadeInZoomAnimMin = keyframes`
 0% {
   opacity: 0;
   transform: scale(0.9);
 }

 100% {
   opacity: 1;
   transform: scale(1);
 }
`;
